import "./index.css";

export const Spinner = () => <div className="Spinner" />;
